module.exports = __webpack_public_path__ + "img/14.84fb7aa5.jpg";